import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

import numbers from "core/numbers";

import Box from "ui/atom/Box";
import Icon from "ui/atom/Icon";

import { usePay } from "features/pay/fabric";
import CheckboxTile from "features/pay/ui/CheckboxTile";


Payment.Tooltip = () => {
	const pay = usePay();
	const theme = useTheme();

	const style = {
		root: {
			alignItems: "center", justifyContent: "center",
			background: theme.palette.background.dark,
			borderRadius: "12px",
			p: theme.spacing(1, 2)
		},
		icons: { alignItems: "center" },
		coin: { width: 16 }
	};

	return (
		<Box gap={1.25} sx={style.root}>
			<Box gap={1.25} sx={style.icons}>
				<Icon name="wallet" size={16} /> + <Icon.Coin size={16} />
			</Box>
			<Typography component="span" variant="body4" color="text.secondary">
				We’ll add {numbers.format(pay.store.token?.tokens, "number")} <Typography component="span" variant="body4" color="text.coin">tokens</Typography> to your Subly wallet
			</Typography>
		</Box>
	);
};

Payment.Auto = () => {
	const pay = usePay();

	return (
		<CheckboxTile checked={pay.store.reload} onChange={pay.store.toggleAuto}>
			<Typography variant="caption">Automatic reload</Typography>
			<Typography variant="body3">Automatically reload my account when my balance is low</Typography>
			<Typography variant="body4" color="text.secondary">This can be changed in account settings</Typography>
		</CheckboxTile>
	);
};

export default function Payment() { return null; }